import React, { forwardRef, memo, useMemo } from "react";
import { NavbarItems } from "./constants/Dropdown.constants.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import DropdownSection from "./components/DropdownSection.tsx";
import {
  NavbarItemsEnum,
  RastreamentoItemsEnum,
} from "./interfaces/Dropdown.enum.ts";

interface DropdownRastreamentoProps {
  ref: React.RefObject<HTMLDivElement>;
}

const DropdownRastreamento = forwardRef<
  HTMLDivElement,
  DropdownRastreamentoProps
>(({}, ref) => {
  const { coresEmpresa } = useProfile();

  const rastreamentoSections =
    NavbarItems[NavbarItemsEnum.RASTREAMENTO].sections;

  const rastreamentoItems =
    rastreamentoSections[RastreamentoItemsEnum.RASTREAMENTO].items;

  const rastreamentoRotasItems =
    rastreamentoSections[RastreamentoItemsEnum.ROTAS].items;

  const sortedRastreamentoRotasItems = useMemo(() => {
    return rastreamentoRotasItems.sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }, []);

  const sortedRastreamentoItems = useMemo(() => {
    return rastreamentoItems.sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  const memorizedRastreamentoItems = useMemo(() => {
    return sortedRastreamentoItems.map((item) => (
      <RotaItem key={`rastreamento-${item.rota}`} item={item} />
    ));
  }, [sortedRastreamentoItems, coresEmpresa.textoBotaoNormal]);

  const memorizedRastreamentoRotasItems = useMemo(() => {
    return sortedRastreamentoRotasItems.map((item) => (
      <RotaItem key={`rastreamentoRotas-${item.rota}`} item={item} />
    ));
  }, [sortedRastreamentoRotasItems, coresEmpresa.textoBotaoNormal]);

  return (
    <div ref={ref} className="dropdown-content-emb">
      <div className="separador-menu-rotas" />
      <div className="content-menu-rows">
        <DropdownSection
          titleSection={
            rastreamentoSections[RastreamentoItemsEnum.ROTAS].titleSection
          }
          icon={rastreamentoSections[RastreamentoItemsEnum.ROTAS].icon}
          children={memorizedRastreamentoRotasItems}
        />
        <DropdownSection
          titleSection={
            rastreamentoSections[RastreamentoItemsEnum.RASTREAMENTO]
              .titleSection
          }
          icon={rastreamentoSections[RastreamentoItemsEnum.RASTREAMENTO].icon}
          children={memorizedRastreamentoItems}
        />
      </div>
    </div>
  );
});

export default memo(DropdownRastreamento);
